export default "__VITE_ASSET__DpgTTOIw__"